import React, { useState, useEffect } from "react";
import { Row, Col, Tag, Card, Skeleton } from "antd";
import { API } from "aws-amplify";
import _ from "lodash";
import MainHeader from "../../../../common/MainHeader";
import ContactInfo from "./ContactInfo";

export default function PrimaryContacts(props) {
  const [isLoading, setLoading] = useState(true);
  const [groupMembersList, setGroupMembersList] = useState([]);
  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    const { profileId } = props;
    if (profileId) {
      getMembersList(profileId);
    }

    if (props?.contactInfo) {
      setContactInfo(props?.contactInfo);
    }
  }, [props]);

  const getMembersList = async (profileId) => {
    setLoading(true);
    await API.get("get", `/mobile/getSupportNetworkMembers/${profileId}`, {})
      .then(async (response) => {
        if (response?.membersList?.length > 0) {
          let emergencyMembers = response.membersList.filter((member) => {
            if (member?.relationShip.toLowerCase()?.indexOf("emergency") > -1) {
              return member;
            }
          });
          if (emergencyMembers.length > 0) {
            let sortedEmergencyMembers = _.sortBy(
              emergencyMembers,
              "relationShip"
            );
            setGroupMembersList(sortedEmergencyMembers);
            setLoading(false);
          } else {
            setGroupMembersList([]);
            setLoading(false);
          }
          props?.emergencyCount(emergencyMembers.length);
        } else {
          props?.emergencyCount(0);
          setGroupMembersList([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.response);
        alert("Something went wrong");
        setGroupMembersList([]);
        setLoading(false);
      });
  };

  return (
    <Col span={24}>
      <div>
        {groupMembersList.length > 0 && (
          <MainHeader
            // title={"Primary Contacts ( " + groupMembersList.length + " )"}
            title={"Primary Contacts"}
          />
        )}

        <div
          className="primary-card"
          style={{
            background: groupMembersList.length > 0 ? "#f5f5f5" : "#fff",
          }}
        >
          {groupMembersList.length > 0 ? (
            <div>
              {groupMembersList.map((member, index) => (
                <Skeleton avatar title={false} loading={isLoading} active>
                  <Card
                    className="card-container"
                    hoverable
                    bodyStyle={{ padding: "5px", margin: "0px" }}
                    style={{ marginTop: "5px" }}
                  >
                    <Row gutter={[8, 8]} justify={"start"}>
                      <Col>
                        <div>
                          <span style={{ fontSize: "10px", color: "#a5a5a5" }}>
                            {member.relationShip}
                          </span>
                        </div>
                        <div>
                          <span style={{ fontSize: "14px" }}>
                            {member?.firstName + " " + member?.lastName}{" "}
                          </span>
                        </div>
                        <div>
                          <span style={{ fontSize: "14px" }}>
                            <Tag color="#f5f5f5" style={{ color: "#000" }}>
                              {member?.mobile}
                            </Tag>
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </Skeleton>
              ))}
            </div>
          ) : (
            <ContactInfo contactInfo={contactInfo} showAllInfo={true} />
          )}
        </div>
      </div>
    </Col>
  );
}
